// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3c3sh","title":"Header_title__1VFip","left":"Header_left__1C8Wa","clinicName":"Header_clinicName__1Hh0p"};